import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SessionService {
	get<T>(sessionKey: string): T {
		return JSON.parse(localStorage.getItem(sessionKey)) as T;
	}

	put(sessionKey: string, value: any): void {
		return localStorage.setItem(sessionKey, JSON.stringify(value));
	}
}
